import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { ACCREDITED_ESTABLISHMENTS_ADDRESS_FILTER } from '@/global/constants/reactQueryKeys'
import {
  getAddressFilterOptions,
  GetFilterResponse
} from '@/modules/accredited-establishments/api'
import { addError } from '@/global/plugins/observability'
import {
  AccreditedEstablishmentsCode,
  Context
} from '@/global/plugins/observability/observability.constants'
import { AxiosError } from 'axios'
import { toastApiError } from '@/global/utils'
import { ApiErrorResponse } from '@/global/api/types'

export interface UseGetPlansFilterProps {
  addressSearchLabel?: string
}

export const useGetAddressesFilter = ({
  addressSearchLabel
}: UseGetPlansFilterProps) => {
  const result = useQuery<GetFilterResponse, AxiosError<ApiErrorResponse>>({
    queryKey: [...ACCREDITED_ESTABLISHMENTS_ADDRESS_FILTER, addressSearchLabel],
    queryFn: () => getAddressFilterOptions({ search: addressSearchLabel! }),
    enabled: Boolean(addressSearchLabel)
  })

  const { error } = result

  useEffect(() => {
    if (error) {
      const data = {
        context: Context.ACCREDITED_ESTABLISHMENTS,
        code: AccreditedEstablishmentsCode.GET_ADDRESS_FILTER_OPTIONS_ERROR,
        message: `Erro ao obter os endereços com a busca "${addressSearchLabel}"`
      }
      addError({ error, data })

      toastApiError({ status: error.response?.status })
    }
  }, [error, addressSearchLabel])

  return result
}
